// extracted by mini-css-extract-plugin
export var about = "about-me-module--about--2vHvT";